import { reqGET } from "../src/Utils";
import { getTokenInfo } from './UseToken';

import { api_list_route } from '../src/components/WEBContent/PerfisMenus/Config';

import SidebarData from "./components/Sidebar/SideBarData";

import Main from './components/Main/Init'

import Calendar_Event from './components/Calendar/Event/Init'
import Calendar_Category from './components/Calendar/Category/Init'

import Content from './components/WEBContent/Content/Init'
import Content_News from './components/WEBContent/News/Init'
import Content_Banner from './components/WEBContent/Banner/Init'
import Content_Gallery from './components/WEBContent/Gallery/Init'
import Content_Testemony from './components/WEBContent/Testemony/Init'
import Content_Category from './components/WEBContent/Category/Init'
import Content_Contest from './components/WEBContent/Contest/Init'

import Formation_Courses from './components/Formation/Courses/Init'
import Formation_Category from './components/Formation/Category/Init'
import Formation_Module from './components/Formation/Module/Init'

import Courses from './components/Courses/Init'


import MonitoringEntity from './components/Entities/Entidade/Init'
import MonitoringOperation from './components/Energy/Operation/Init'
import MonitoringConsumos from './components/Energy/Consumos/Init'
import MonitoringAutoConsumo from './components/Energy/Autoconsumo/Init'
import MonitoringPlanoAccao from './components/Energy/PlanoAccao/Init'
import MonitoringResultados from './components/Energy/Resultados/Init'




import Perfil from './components/WEBContent/PerfisMenus/Init'
import Perfis_Menus from './components/WEBContent/PerfisMenus/Init'
import Structure from './components/WEBContent/Structure/Init'
import Utilizador from './components/Entities/Utilizador/Init'

import Formador from './components/Entities/Formador/Init'
import Formando from './components/Entities/Formando/Init'
import Note from './components/Notes/Init'
import Message from './components/Messages/Init'

export default function UseSidebar() {

  const getSidebar = async (profile, isEdit = false) => {

    let sidebar_init = SidebarData({
      rotas: {
        Main: Main,
        
        Calendar_Event: Calendar_Event,
        Calendar_Category: Calendar_Category,

        Content: Content,
        Content_News: Content_News,
        Content_Banner: Content_Banner,
        Content_Gallery: Content_Gallery,
        Content_Testemony: Content_Testemony,
        Content_Category: Content_Category,
        Content_Contest: Content_Contest,

        Formation_Courses: Formation_Courses,
        Formation_Category: Formation_Category,
        Formation_Module: Formation_Module,

        Courses: Courses,

        


        MonitoringEntity: MonitoringEntity,
        MonitoringOperation: MonitoringOperation,
        MonitoringConsumos: MonitoringConsumos,
        MonitoringAutoConsumo: MonitoringAutoConsumo,
        MonitoringPlanoAccao: MonitoringPlanoAccao,
        MonitoringResultados: MonitoringResultados,
        



        Perfil: Perfil,
        Perfis_Menus: Perfis_Menus,
        Utilizador: Utilizador,
        Structure: Structure,

        Formador: Formador, 
        Formando: Formando,
        Note: Note,
        Message: Message,

      }
    })

    let companycodeLS = getTokenInfo().companycode
    //console.log(companycodeLS)

    if (companycodeLS === null || profile === null) {
      return sidebar_init
    }
    else {
     
      let result = await reqGET(api_list_route(companycodeLS))
        .then(res => {

          let profiles_list = res.data.filter(item => item.name === profile)
        
          let update_sidebar =(sidebar_original, sidebar_db) => {

            sidebar_original.forEach(element => {
  
                let tmp = sidebar_db.filter(e => e.id === element.id)

                if (tmp.length > 0){

                /*   element.title  =   element[0].title
                  element.path   =   element[0].path
                  element.icon   =   element[0].icon
                  element.icon_b =   element[0].icon_b
                  element.cName  =   element[0].cName */
                  element.allow  =   tmp[0].allow
                  element.create =   tmp[0].create
                  element.edit   =   tmp[0].edit
                  element.view   =   tmp[0].view
                  element.remove =   tmp[0].remove

                  update_sidebar( element.submenu, tmp[0].submenu)
                }

 
              })
              return sidebar_original
            }
         
          if (isEdit === true) {
           
            return update_sidebar( sidebar_init , profiles_list[0].permissions.menu )

          } else {
          
            return profiles_list.length > 0 ? profiles_list[0].permissions.menu : sidebar_init

          }

        })

      return result
    }
  }

  return {
    getSidebar,
  }
}